/**
 * URL-hash keys for the photo-scanning feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#pdf/5`).
 */
export const PHOTO_SCANNING_HASH = {
  // listing overlays
  pdf: 'pdf', // #pdf/<batchId> — BatchPdfViewer Dialog (listing)
  refuse: 'refuse', // #refuse/<batchId> — MoveToRepairDialog (listing "move to repair")
  bulkDelete: 'bulk-delete', // #bulk-delete — action bar
  // execution page overlays (ExecutionTab)
  rearrange: 'rearrange', // #rearrange — RearrangePagesDialog
  quarantine: 'quarantine', // #quarantine — QrQuarantinePanel (needs-action hold)
  // execution right-panel + progress-header overlays
  bulkDeletePages: 'bulk-delete-pages', // #bulk-delete-pages — bulk delete pages AlertDialog (scan-right-panel)
  deletePage: 'delete-page', // #delete-page/<pageId> — single page delete AlertDialog (scan-right-panel)
  moveToRepair: 'move-to-repair', // #move-to-repair — MoveToRepairDialog (scan-progress-header)
  deviceForm: 'device-form' // #device-form — DeviceFormDialog (dwt-scanner-panel)
} as const;
export type PhotoScanningHashKey =
  (typeof PHOTO_SCANNING_HASH)[keyof typeof PHOTO_SCANNING_HASH];
